var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40679 13.6232C1.86857 13.6232 2.08547 13.3853 2.16243 13.0145L3.47781 6.81545H7.25602L8.57839 13.0145C8.66235 13.3853 8.87925 13.6232 9.33404 13.6232C9.95674 13.6232 10.1736 13.1615 10.0617 12.6437L8.68334 6.2907C8.5644 5.77994 8.16559 5.38813 7.67582 5.33915L6.05959 0.784305C5.94764 0.462458 5.71675 0.273547 5.37391 0.273547C5.01708 0.273547 4.77219 0.462458 4.66025 0.784305L3.05101 5.34615C2.56824 5.38813 2.16243 5.77994 2.05048 6.2837L0.686127 12.6437C0.567184 13.1615 0.798075 13.6232 1.40679 13.6232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkIcon);
export default __webpack_public_path__ + "static/media/mark_icon.37ed2d68058a80c73499d9afd0a821dc.svg";
export { ForwardRef as ReactComponent };